// extracted by mini-css-extract-plugin
module.exports = {"build_info":"build_info_build_info__6YYBT"};